<template>
    <div id="wx_head" class="card-container">
        <a-card hoverable class="wx_in">
            <div class="title cross_center base_font_size_14 base_font_color_606266">
                <a-icon type="user" style="margin-right: 5px;font-size: 16px;color:#ff5800" />
                机汇管家
            </div>
            <a-divider style="margin: 10px 0;" />
            <div class="cont base_font_size_12">
                <ul>
                    <li>性别 男</li>
                    <li class="main_between cross_center">
                        <div class="left_text">
                            设置备注和描述
                        </div>
                        <a-icon type="right" />
                    </li>
                    <li class="main_between cross_top">
                        <div class="left_text flex_wrap cross_top">
                            <i>标签</i>
                            <template v-for="(item, index) in data">
                                <span :key="index" v-if="item.tagName">{{ item.tagName }}</span>
                            </template>
                        </div>
                        <a-icon type="right" />
                    </li>
                </ul>
            </div>
        </a-card>
        <div class="wx_txt base_font_size_12 base_font_color_909399">扫码标签样式</div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: []
        }
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    watch: {
        data(val) {
            console.log('wx_head_watch:', val);
        }
    },
    methods: {}
};
</script>

<style>
#wx_head .title {
    line-height: 1;
}
#wx_head .cont {
    padding-top: 5px;
}
#wx_head .cont ul {
    margin: 0;
    padding: 0;
}
#wx_head .cont li {
    line-height: 2;
    padding: 0 10px 0 0;
    margin-bottom: 10px;
}
#wx_head .left_text i,
#wx_head .left_text span {
    font-style: inherit;
    margin-right: 5px;
    margin-bottom: 10px;
    line-height: 1;
}
#wx_head .left_text span {
    background-color: #efeff4;
}
#wx_head .wx_txt {
    line-height: 3;
}
</style>
